import { Currency } from "dinero.js"
import { useFormikContext } from "formik"

import { useMoney } from "../../../../../currency/useMoney"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../../localization/useDateTime"
import { useNumber } from "../../../../../localization/useNumber"

import { PriceAdjustmentType } from "../../priceListTypes"
import { AdjustPricesFormValues, formatAdjustmentValue } from "./adjustPricesLib"

type AdjustmentPanelSubtitleProps = Readonly<{
    itemCount: number
    currency: Currency<number>
}>

export function AdjustmentPanelSubtitle({ itemCount, currency }: AdjustmentPanelSubtitleProps) {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})
    const numberFactory = useNumber({})
    const { values } = useFormikContext<AdjustPricesFormValues>()

    if (values.value === "" || !values.effectiveFrom) {
        return (
            <LocalizedStrict id="adjust-price-list-summary-empty">
                <span>Choose how much to change the prices by, and from which date.</span>
            </LocalizedStrict>
        )
    }

    const isIncrease = values.adjustmentType === PriceAdjustmentType.INCREASE
    const value = formatAdjustmentValue(moneyFactory, numberFactory, values.unit, values.value, currency)
    const date = dateTimeFactory.formatLongDate(values.effectiveFrom)

    return (
        <LocalizedStrict
            id={isIncrease ? "adjust-price-list-summary-raises" : "adjust-price-list-summary-lowers"}
            vars={{ count: itemCount, value, date }}
        >
            <span>
                {isIncrease ? "Raises" : "Lowers"} {itemCount} items by {value} from {date}.
            </span>
        </LocalizedStrict>
    )
}
